import React from 'react';
import LegalLayout from './LegalLayout';
import { LEGAL_DOCUMENTS } from './legal-content.generated';

/**
 * Renders one legal document from the shared, generated content.
 *
 * The document bodies used to be inline JSX in each of the four page files. They
 * are now generated from `content/legal/*.md` by `pnpm legal:build` and shipped
 * to both hosts as committed artifacts, so the copy a tenant reads at
 * `{slug}.nurturecrm.ai/privacy` and the copy a reviewer reads at
 * `nurturecrm.ai/privacy` are the same bytes. A CI drift check enforces that —
 * "shared source" nobody enforces becomes two sources within a sprint, and a
 * reviewer who finds the tenant and apex privacy pages disagreeing about Gmail
 * data has found a real inconsistency that costs a re-review cycle.
 *
 * `dangerouslySetInnerHTML` is safe here: the HTML is repo-authored Markdown,
 * rendered and tag-allowlisted at build time, and never contains user input.
 */
export default function LegalDocument({ slug }) {
    const doc = LEGAL_DOCUMENTS[slug];
    if (!doc) return null;

    const effective = new Date(`${doc.effectiveDate}T00:00:00Z`).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC',
    });

    return (
        <LegalLayout title={doc.title} lastUpdated={`${effective} · v${doc.version}`}>
            <div dangerouslySetInnerHTML={{ __html: doc.html }} />
        </LegalLayout>
    );
}
